import React, { useState, useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useQuery, useQueryClient } from "react-query";
import { getTicketDetailById } from "../../services/game.service";
import html2canvas from "html2canvas";
import safeHtml2canvas from "../../utils/safeHtml2canvas";

interface PopUpRewardPointProps {
  open: boolean;
  rewardAmount: string;
  onClose: () => void;
}

export default function PopUpRewardPoint({
  open,
  rewardAmount,
  onClose,
}: PopUpRewardPointProps) {
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);
  const [imageScratch, setImageScratch] = useState<string>("");
  const [resultData, setResultData] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (divRef.current && open) {
        try {
          const dataUrl = await safeHtml2canvas(divRef.current, {
            scale: 2,
            backgroundColor: null,
          });
          if (!cancelled) setImageScratch(dataUrl || "");
          if (!dataUrl) console.warn("PopUpRewardPoint: html2canvas returned null (fallback)");
        } catch (err) {
          console.warn("PopUpRewardPoint: html2canvas failed", err);
          if (!cancelled) setImageScratch("");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [open]);
  // console.log("ticketDetail?.lv2Type:::", ticketDetail?.lv2Type);

  return (
    <>
      <Modal
        show={open}
        onHide={() => {}}
        keyboard={false}
        style={{ border: "none" }}
        centered
        size="sm"
        contentClassName="bg-transparent border-0 shadow-none"
        closeButton={false}
      >
        <div className="relative">
          <img
            src="/images/popup-point.png"
            alt="texture"
            className="w-full"
            style={{
              // Force GPU compositing on Android
              transform: "translate3d(0,0,0)",
              WebkitTransform: "translate3d(0,0,0)",
              willChange: "transform",
            }}
          />
          {/* button transparent */}
          <div
            className="absolute left-0 right-0 w-[40%] flex justify-center items-center mx-auto cursor-pointer"
            style={{
              // Responsive font-size: scales with viewport width, clamped between 24px and 36px
              fontSize: "clamp(24px, 4vw, 36px)",
              fontWeight: "bold",
              aspectRatio: 7 / 2,
              bottom: "25%",
              lineHeight: 1,
              color: "#0041a6",
            }}
          >
            {rewardAmount}
          </div>
          <div
            onClick={() => {
              onClose();
            }}
            className="absolute left-0 right-0 w-[40%] mx-auto cursor-pointer bg-transparent"
            style={{
              aspectRatio: 8 / 3,
              bottom: "11%",
            }}
          ></div>
        </div>
      </Modal>
    </>
  );
}
